<template>
  <div>
    <div class="topHeader">
      <span> 이용자 정보 </span>
    </div>
    <div class="item">
      <div class="row d-flex">
        <div class="rowHeader">
          <span class="headerText">성명 </span>
        </div>
        <div class="rowContent">
          <div class="rowCheckContent">
            <FormRequiredInputCharHangul
              v-if="!isLoggedIn"
              class="col mr-4"
              :readonly="isLoggedIn"
              v-model="userInfo.bookName"
            ></FormRequiredInputCharHangul>
            <FormRequiredInput
              v-if="isLoggedIn"
              class="col mr-4"
              :readonly="isLoggedIn"
              v-model="userInfo.bookName"
            ></FormRequiredInput>
          </div>
        </div>
      </div>
      <div class="rowSpace"></div>
      <div class="row">
        <div class="rowHeader">
          <span class="headerText"> 연락처 </span>
        </div>
        <div class="rowContent">
          <div class="rowCheckContent">
            <FormTel class="col mr-4" :readonly="isLoggedIn" v-model="userInfo.bookHpNo"></FormTel>
          </div>
          <div class="rowCheckContent">연락 드릴 수 있는 연락처(휴대폰 11자리) 입력 바랍니다.</div>
        </div>
      </div>
      <div class="rowSpace"></div>
      <div class="row">
        <div class="rowHeader">
          <span class="headerText">이메일</span>
        </div>
        <div class="rowContent">
          <div class="rowCheckContent">
            <FormRequiredInput class="col mr-4" v-model="userInfo.email"></FormRequiredInput>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormRequiredInput from '@/components/forms/FormRequiredInput';
import FormTel from '@/components/forms/FormTel';
import GeneralUtil from '@/util/GeneralUtil';
import FormRequiredInputCharHangul from '@/components/forms/FormRequiredInputCharHangul';

export default {
  name: 'UserInfoInput',
  props: {
    userInfo: Object,
  },
  mixins: [GeneralUtil],
  components: {FormTel, FormRequiredInput, FormRequiredInputCharHangul},
  computed: {
    options_RealUserSelfOrFamily() {
      // [
      //   { value: 'Y', text: '본인 내장' },
      //   { value: 'N', text: '배우자 내장' },
      // ];
      // TODO : 회원권 여러개 있는 회원일 경우(극소수) memInfoArr[0] 이외의 다른 값 선택 필요함
      const memberSelected = this.selectedMember;

      // 본인
      let res = [
        {
          value: {
            gscName: this.loginUser.guestName.trim(),
            gscHpNo: this.loginUser.hpNo.trim(),
          },
          text: `${memberSelected.guestTypeName}`,
        },
      ];

      // 가족 리스트
      if (memberSelected.familyInfoArr && memberSelected.familyInfoArr.length > 0) {
        this.selectedMember.familyInfoArr.forEach(x => {
          res.push({
            value: {
              gscName: x.guestName.trim(),
              gscHpNo: x.hpNo.trim(),
            },
            text: `${x?.relationName}`,
          });
        });
      }

      return res;
    },
  },
  data() {
    return {
      selected_RealUserSelfOrFamily: {
        gscName: '',
        gscHpNo: '',
      },
      bookHpNoReadOnly: false,
    };
  },
  created() {
    if (this.isLoggedIn) {
      //console.log(this.loginUser);
      this.userInfo.bookName = this.loginUser.guestName;
      this.userInfo.bookHpNo = this.loginUser.hpNo;

      this.selected_RealUserSelfOrFamily.gscName = this.userInfo.bookName;
      this.selected_RealUserSelfOrFamily.gscHpNo = this.userInfo.bookHpNo;

      this.bookHpNoReadOnly = true;
    }
  },
  methods: {
    getReservRemarks() {
      if (this.selectedMember?.memType === '012' || this.selectedMember?.memType === '011') {
        return '예약자와 투숙객이 다른 경우 기재부탁드립니다.';
      }
      return '';
    },
    selected_RealUserSelfOrFamily_Changed(value) {
      //console.log('selected_RealUserSelfOrFamily_Changed', value, rd);
      this.userInfo.bookName = value.gscName;
      this.userInfo.bookHpNo = value.gscHpNo;
      if (!this.userInfo.bookHpNo.trim()) {
        this.bookHpNoReadOnly = false;
      } else {
        this.bookHpNoReadOnly = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.topHeader {
  padding-top: 1rem;
  padding-left: 2rem;
  font-weight: bold;
  font-size: 1.3rem;
}

.item {
  border: 1px solid #cfcfcf;
  margin: 1rem;
  padding: 1rem;
}

.row {
  display: flex;
  padding-left: 1rem;
  padding-right: 1rem;
  line-height: 3rem;
}

.rowHeader {
  flex: 1;
  text-align: left;
  line-height: 2.6rem;
  font-weight: bold;
}
.rowContent {
  flex: 5;
  line-height: 2.6rem;
}

.rowCheckContent {
  flex: 1;
  display: flex;
  line-height: 2.6rem;
}
.rowSpace {
  height: 0.5rem;
}
.colSpace {
  width: 0.3rem;
  border: 0px;
}
article {
  position: relative;
  width: 6rem;
  //width: 30%;
  height: 2.3rem;
  margin: 0.2rem;
  float: left;

  box-sizing: border-box;
}

article div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 25px;
  transition: 0.1s ease;
  border: 1px solid #bdbdbd;
}

article input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

input[type='checkbox']:checked ~ div {
  background-color: #3b352a;
  color: #dddddd;
}

input[type='checkbox']:disabled ~ div {
  background-color: #eeeeee;
  color: #afafaf;
  border: 1px solid #d1d1d1;
}
.checkArea {
  width: 8rem;
}

@media (max-width: 992px) {
  .rowCheckContent {
    display: block;
  }

  .headerText {
    font-size: 0.8rem;
  }

  .item {
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 0rem;
    margin-right: 0rem;
  }
}

.checkBoxContainer {
  line-height: 1.6rem;
}
</style>
